(function() {

  // ============================================================
  // CONFIG
  // ============================================================
  var PRODUCT_HANDLE = 'purahome-cookware-set';
  var DEFAULT_PRODUCT_OPT = 'Fry Pan';

  // Cards keyed by option1 value — must match Shopify variant option1 EXACTLY.
  // image = the picture shown inside each card (edit these to change card art).
  var VARIANT_META = {
    'Fry Pan': {
      title: 'Fry\nPan',
      subtitle: '(Fry pan)',
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/Untitled_design_14_copy.png?v=1779695815'
    },
    'Everyday Duo': {
      title: 'Everyday\nDuo',
      subtitle: '(Sauté pan + Dutch Oven)',
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/8_9dc4b8dd-b692-4569-8714-1610ba082498.png?v=1779408836'
    },
    'Complete Set': {
      title: 'Complete\nSet',
      subtitle: '(full set)',
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/9_c603536a-551f-4b3b-9e70-a6bbe68d6c9a.png?v=1779408836'
    }
  };

  // Left -> right display order
  var PRODUCT_ORDER = ['Fry Pan', 'Everyday Duo', 'Complete Set'];

  var CURRENCY_SYMBOLS = {
    'AUD': '$', 'USD': '$', 'CAD': '$', 'NZD': '$', 'SGD': '$', 'HKD': '$',
    'GBP': '£', 'EUR': '€', 'JPY': '¥', 'CNY': '¥', 'INR': '₹',
    'CHF': 'Fr', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'ZAR': 'R',
    'MXN': '$', 'BRL': 'R$', 'AED': 'د.إ', 'SAR': '﷼', 'THB': '฿',
    'MYR': 'RM', 'IDR': 'Rp', 'PHP': '₱', 'KRW': '₩', 'TRY': '₺',
  };

  // Afterpay (reused from the filter pickers)
  var AFTERPAY_CURRENCIES = ['AUD', 'NZD', 'USD', 'CAD', 'GBP'];
  var AFTERPAY_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/after-pay.svg?v=1752685514';

  // ============================================================
  // STATE
  // ============================================================
  var state = { product: null };

  // ============================================================
  // CURRENCY HELPERS
  // ============================================================
  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active : 'AUD';
  }
  function getCurrencySymbol(currency) {
    return CURRENCY_SYMBOLS[currency] || '$';
  }
  // Whole-dollar display (rounds .99 -> next dollar)
  function formatMoney(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      return symbol + new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(Math.round(amount));
    } catch(e) { return '$' + Math.round(amount); }
  }
  function calcSavePct(price, comparePrice) {
    if (!comparePrice || comparePrice <= price) return null;
    return Math.round((1 - price / comparePrice) * 100);
  }
  function calcSaveDollar(price, comparePrice) {
    if (!comparePrice || comparePrice <= price) return null;
    return comparePrice - price;
  }

  // ============================================================
  // VARIANT LOOKUP (single dimension now — option1 only)
  // ============================================================
  function findVariant(variants, productOpt) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].option1 === productOpt) return variants[i];
    }
    return null;
  }

  // ============================================================
  // OWN PRICE HEADER (compare / sale / SAVE badge + Afterpay + divider)
  // ============================================================
  function buildPriceHeader() {
    var existing = document.getElementById('ph-price-header');
    if (existing) existing.parentNode.removeChild(existing);

    var picker = document.getElementById('ph-variant-picker');
    if (!picker) return;

    var header = document.createElement('div');
    header.id = 'ph-price-header';
    var compareEl = document.createElement('span'); compareEl.id = 'ph-header-compare'; compareEl.className = 'ph-header-compare';
    var saleEl    = document.createElement('span'); saleEl.id = 'ph-header-sale'; saleEl.className = 'ph-header-sale';
    var badgeEl   = document.createElement('span'); badgeEl.id = 'ph-header-badge'; badgeEl.className = 'ph-header-badge';
    header.appendChild(compareEl); header.appendChild(saleEl); header.appendChild(badgeEl);
    picker.insertBefore(header, picker.firstChild);

    // Afterpay strip
    var apStrip = document.createElement('div');
    apStrip.id = 'ph-afterpay';
    var apText = document.createElement('span');
    apText.innerHTML = 'or 4 payments of <strong id="ph-afterpay-amount"></strong> with';
    var apLogo = document.createElement('img');
    apLogo.src = AFTERPAY_LOGO_URL; apLogo.alt = 'Afterpay'; apLogo.className = 'ph-afterpay-logo';
    apStrip.appendChild(apText); apStrip.appendChild(apLogo);
    picker.insertBefore(apStrip, header.nextSibling);

    // Divider
    var divider = document.createElement('hr');
    divider.id = 'ph-divider';
    picker.insertBefore(divider, apStrip.nextSibling);
  }

  function updatePriceHeader(variant, currency) {
    var price = variant.price;
    var comparePrice = variant.compare_price;
    var saveDollar = calcSaveDollar(price, comparePrice);

    var compareEl = document.getElementById('ph-header-compare');
    var saleEl    = document.getElementById('ph-header-sale');
    var badgeEl   = document.getElementById('ph-header-badge');

    if (saleEl) saleEl.textContent = formatMoney(price, currency);
    if (compareEl) {
      if (comparePrice && comparePrice > price) {
        compareEl.textContent = formatMoney(comparePrice, currency);
        compareEl.style.display = '';
      } else { compareEl.style.display = 'none'; }
    }
    if (badgeEl) {
      if (saveDollar && saveDollar > 0) {
        badgeEl.textContent = 'SAVE ' + formatMoney(saveDollar, currency);
        badgeEl.style.display = '';
      } else { badgeEl.style.display = 'none'; }
    }

    var apStrip  = document.getElementById('ph-afterpay');
    var apAmount = document.getElementById('ph-afterpay-amount');
    if (apStrip && apAmount) {
      if (AFTERPAY_CURRENCIES.indexOf(currency) !== -1) {
        var sym = getCurrencySymbol(currency);
        try {
          apAmount.textContent = sym + new Intl.NumberFormat(undefined, {
            minimumFractionDigits: 2, maximumFractionDigits: 2
          }).format(price / 4);
        } catch(e) { apAmount.textContent = sym + (price/4).toFixed(2); }
        apStrip.style.display = '';
      } else { apStrip.style.display = 'none'; }
    }
  }

  // ============================================================
  // (Image swap removed — Option B. The main gallery is left untouched;
  //  each card shows its own product image so the choice is clear at the
  //  point of selection. To change a card image, edit VARIANT_META.image.)
  // ============================================================

  // ============================================================
  // PAGE PRICE + FORM SYNC
  // ============================================================
  function applySelection(variant, currency, isInitial) {
    updatePriceHeader(variant, currency);

    // ATC button price
    document.querySelectorAll('button[name="add"], .gp-btn-atc, [class*="add-to-cart"], [class*="atc"]').forEach(function(btn) {
      var text = btn.textContent || '';
      if (text.indexOf('$') > -1 || text.indexOf('£') > -1 || text.indexOf('€') > -1 || text.indexOf('¥') > -1) {
        btn.innerHTML = btn.innerHTML
          .replace(/[£€¥₹₩₺฿][\d,]+\.?[\d]*/g, formatMoney(variant.price, currency))
          .replace(/\$[\d,]+\.?[\d]*/g, formatMoney(variant.price, currency));
      }
    });

    // On initial page load, do NOT sync the form — only sync on real user clicks.
    if (isInitial) return;

    // Form inputs (needed so Add to Cart submits the right variant).
    // We deliberately do NOT write ?variant= to the URL — that param makes
    // GemPages' gallery jump to a variant image, which we don't want.
    document.querySelectorAll('input[name="id"]').forEach(function(inp) {
      if (inp.type !== 'radio') { inp.value = variant.id; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    document.querySelectorAll('[data-product-form], form[action*="/cart/add"]').forEach(function(form) {
      var input = form.querySelector('input[name="id"]');
      if (input) { input.value = variant.id; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }

  // ============================================================
  // CARD PRICES
  // ============================================================
  function updateCardPrices(variants, currency, cardsContainer) {
    cardsContainer.querySelectorAll('.ph-card').forEach(function(card) {
      var variant = findVariant(variants, card.dataset.productOpt);
      if (!variant) return;

      var pricesEl = card.querySelector('.ph-card-prices');
      if (!pricesEl) return;
      pricesEl.innerHTML = '';
      if (variant.compare_price && variant.compare_price > variant.price) {
        var c = document.createElement('span');
        c.className = 'ph-price-compare';
        c.textContent = formatMoney(variant.compare_price, currency);
        pricesEl.appendChild(c);
      }
      var cur = document.createElement('span');
      cur.className = 'ph-price-current';
      cur.textContent = formatMoney(variant.price, currency);
      pricesEl.appendChild(cur);

      var savePct = calcSavePct(variant.price, variant.compare_price);
      var badge = card.querySelector('.ph-card-badge');
      if (savePct) {
        if (!badge) { badge = document.createElement('div'); badge.className = 'ph-card-badge'; card.insertBefore(badge, card.firstChild); }
        badge.textContent = 'SAVE ' + savePct + '%';
      } else if (badge) { badge.remove(); }
    });
  }

  // ============================================================
  // SELECTION ORCHESTRATOR
  // ============================================================
  function updateSelection(variants, currency, cardsContainer, isInitial) {
    var variant = findVariant(variants, state.product);
    if (!variant) { console.warn('[PH] No variant for', state.product); return; }

    cardsContainer.querySelectorAll('.ph-card').forEach(function(c) {
      c.classList.toggle('ph-selected', c.dataset.productOpt === state.product);
    });

    var meta = VARIANT_META[state.product] || {};
    var labelEl = document.getElementById('ph-selected-label');
    if (labelEl) labelEl.textContent = (meta.title || state.product).replace('\n', ' ') + ' ' + (meta.subtitle || '');

    updateCardPrices(variants, currency, cardsContainer);
    applySelection(variant, currency, isInitial);
  }

  // ============================================================
  // BUILD CARDS
  // ============================================================
  function buildCards(variants, currency, cardsContainer) {
    cardsContainer.innerHTML = '';
    buildPriceHeader();

    // Order by PRODUCT_ORDER, then any extras
    var productOpts = [];
    PRODUCT_ORDER.forEach(function(o) {
      if (variants.some(function(v){ return v.option1 === o; })) productOpts.push(o);
    });
    variants.forEach(function(v) {
      if (productOpts.indexOf(v.option1) === -1) productOpts.push(v.option1);
    });

    productOpts.forEach(function(productOpt) {
      var meta = VARIANT_META[productOpt] || { title: productOpt, subtitle: '', image: null };
      var titleLines = (meta.title || productOpt).split('\n');

      var card = document.createElement('div');
      card.className = 'ph-card';
      card.dataset.productOpt = productOpt;

      var imgWrap = document.createElement('div');
      imgWrap.className = 'ph-card-img-wrap';
      if (meta.image) {
        var imgEl = document.createElement('img');
        imgEl.className = 'ph-card-img';
        imgEl.src = meta.image; imgEl.alt = productOpt;
        imgWrap.appendChild(imgEl);
      } else {
        var ph = document.createElement('div'); ph.className = 'ph-card-img-placeholder'; imgWrap.appendChild(ph);
      }
      card.appendChild(imgWrap);

      var titleEl = document.createElement('div');
      titleEl.className = 'ph-card-title';
      titleEl.innerHTML = titleLines.join('<br>');
      card.appendChild(titleEl);

      var subtitleEl = document.createElement('div');
      subtitleEl.className = 'ph-card-subtitle';
      subtitleEl.textContent = meta.subtitle;
      card.appendChild(subtitleEl);

      var pricesEl = document.createElement('div');
      pricesEl.className = 'ph-card-prices';
      card.appendChild(pricesEl);

      card.addEventListener('click', function() {
        state.product = productOpt;
        updateSelection(variants, currency, cardsContainer, false);
      });

      cardsContainer.appendChild(card);
    });
  }

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    var cardsContainer = document.getElementById('ph-cards-container');
    if (!cardsContainer) { console.warn('[PH] #ph-cards-container missing.'); return; }

    var currency = getCurrency();

    if (!window.variantData || !Array.isArray(window.variantData) || window.variantData.length === 0) {
      cardsContainer.innerHTML = '<div class="ph-loading">No variant data.</div>';
      return;
    }
    var variants = window.variantData;

    // Default selection
    state.product = variants.some(function(v){ return v.option1 === DEFAULT_PRODUCT_OPT; })
      ? DEFAULT_PRODUCT_OPT : variants[0].option1;

    buildCards(variants, currency, cardsContainer);

    updateSelection(variants, currency, cardsContainer, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();